import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBold = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M5.66406 15.8327V4.16602H10.2682C11.171 4.16602 12.0043 4.44379 12.7682 4.99935C13.5321 5.5549 13.9141 6.32574 13.9141 7.31185C13.9141 8.02018 13.7543 8.56532 13.4349 8.94727C13.1155 9.32921 12.8168 9.60352 12.5391 9.77018C12.8863 9.92296 13.2717 10.2077 13.6953 10.6243C14.1189 11.041 14.3307 11.666 14.3307 12.4993C14.3307 13.7355 13.8793 14.6 12.9766 15.0931C12.0738 15.5862 11.2266 15.8327 10.4349 15.8327H5.66406ZM8.1849 13.4993H10.3516C11.0182 13.4993 11.4245 13.3292 11.5703 12.9889C11.7161 12.6487 11.7891 12.4021 11.7891 12.2493C11.7891 12.0966 11.7161 11.85 11.5703 11.5098C11.4245 11.1695 10.9974 10.9993 10.2891 10.9993H8.1849V13.4993ZM8.1849 8.74935H10.1224C10.5807 8.74935 10.9141 8.63129 11.1224 8.39518C11.3307 8.15907 11.4349 7.89518 11.4349 7.60352C11.4349 7.27018 11.3168 6.99935 11.0807 6.79102C10.8446 6.58268 10.5391 6.47852 10.1641 6.47852H8.1849V8.74935Z",
		fill: "#636566"
	})]
});
const ForwardRef = forwardRef(SvgBold);
export { ForwardRef as ReactComponent };
